import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import useSEO from "@/hooks/useSEO";

export default function PaymentCancel() {
  useSEO({ title: "Donation Canceled — The Tandem T Foundation", path: "/payment/cancel" });
  return (
    <div data-testid="payment-cancel" className="min-h-[80vh] flex items-center justify-center px-6 pt-28 pb-20">
      <div className="max-w-xl w-full text-center">
        <XCircle size={44} className="mx-auto text-white/70" />
        <p className="font-serif text-3xl md:text-4xl font-light text-white mt-8">Your donation was canceled.</p>
        <p className="text-white/60 font-light mt-4">
          No charge was made. The mothers, children, and youth we serve are still counting on people like you —
          you're welcome back any time.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link to="/foundation/donate" className="overline px-6 py-4 bg-white text-black hover:bg-white/85 transition-colors">Try Again</Link>
          <Link to="/foundation" className="overline px-6 py-4 border border-white/25 text-white hover:bg-white hover:text-black transition-colors">Back to the Foundation</Link>
        </div>
      </div>
    </div>
  );
}
